/*
 * Program: Mro.jsx
 * Application: Mro
 * Option: to List out of Mro Information
 * Developer: Chandra Shekhar
 * Date: 2022-04-04
 */
import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import SimpleReactValidator from "simple-react-validator";
import { Row, Col } from "react-bootstrap";
import Moment from "moment";
import back from "./../../assets/images/back.svg";
import UserService from "../../services/UserService";
import Select from "react-select";
import DatePicker from "react-datepicker";
import ActionItemService from "../../services/ActionItemService";
import PropertyService from "../../services/PropertyService";
import { Link } from "react-router-dom";
import PropertySelection from "../dashboard/PropertySelection";
export class ActionItem extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      is_inactive: false,
      tableQueryString: "",
      customQueryString: "",
      showFilter: global.showFilter,
      input: {},
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      filter_value: "",
      loading: false,
      showSpinner: false,
      total_record: 0,
      records: [],
      user_slug: "",
      userList: [],
      selectedUserList: [],
      priority_type: "",
      priorityType: [],
      due_date: "",
      status_id: "",
      statusList: [],
      selectedStatusList: [],
      isFilterTrue: false,
      perPage: 0,
      statusFilter: this.props.match.params.status ? this.props.match.params.status : undefined,
      newStatusList: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 2 },
      ],
      config: {
        sort: {
          column: "due_date",
          order: "desc",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: global.show_pagination,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No record found",
          filter: "Search by item no. and title",
        },
      },

      extraButtons: [],
      columns: [
        {
          key: "action_number",
          text: "Item No.",
          className: "mro_number hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.action_number ? "#" + record.action_number : "";
          },
        },
        {
          key: "property_name",
          text: "Property",
          className: "mro_number hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.property && record.property.property_name ? record.property.property_name : "";
          },
        },
        {
          key: "title",
          text: "Title",
          className: "title hand-cursor mro_ttl_p",
          sortable: false,
          cell: (record) => {
            const note = record.title ? this.limitTextTo50Words(record.title) : "";
            return note;
          },
        },
        {
          key: "created_by",
          text: "Created By",
          className: "full_name_conducted hand-cursor",
          sortable: false,
          cell: (record) => {
            return record.full_name_conducted ? record.full_name_conducted : "";
          },
        },
        {
          key: "user_id",
          text: "Assigned To",
          className: "full_name hand-cursor",
          sortable: false,
          cell: (record) => {
            return record.assignee ? record.assignee.full_name : "";
          },
        },
        {
          key: "priority_type",
          text: " Priority",
          className: "priority_type hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.priority_type_name ? record.priority_type_name : "";
          },
        },
        {
          key: "status_id",
          text: "Status",
          className: "status_id hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.status_display ? record.status_display : "";
          },
        },
        {
          key: "due_date",
          text: " Due Date",
          className: "due_date hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.due_date
              ? Moment(record.due_date).format("DD MMM, YYYY")
              : "";
          },
        },
        {
          key: "created_at",
          text: "Property Visit No.",
          className: "created_at hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.audit && record.audit.get_audit
              ? record.audit.get_audit.audit_no
              : "";
          },
        },
      ],
      isFirstLoad: true,
      lastQueryString: "",
      singleScreen: false,
      fistLoad: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.filterToggle = this.filterToggle.bind(this);
    this.resetData = this.resetData.bind(this);
    this.customFilter = this.customFilter.bind(this);
    this.handleChangeUserListCreatedBy = this.handleChangeUserListCreatedBy.bind(this);
    this.getPropertySlug = this.getPropertySlug.bind(this);
  }

  componentDidMount() {
    const savedFilterState = JSON.parse(localStorage.getItem('actionItemFilterState'));
    const savedFormattedData = JSON.parse(localStorage.getItem('formattedDataAction'));
    if (savedFilterState) {
      if (this.state.statusFilter !== undefined) {
        var statusLocal = 0;
        if (this.state.statusFilter === "pending") {
          statusLocal = 1;
        }
        if (this.state.statusFilter === "overdue") {
          statusLocal = 3;
        }
        if (this.state.statusFilter === "completed") {
          statusLocal = 2;
        }
        let actionStatus = global.actionItemStatus;
        var selectedDashboardStatus = [];
        actionStatus.map((i) => {
          if (i.value === status) {
            selectedDashboardStatus.push(i);
          }
        });
      }
      this.setState({
        user_slug: savedFilterState.user_slug,
        priority_type: savedFilterState.priority_type,
        status_id: statusLocal == undefined ? savedFilterState.status_id : statusLocal,
        user_slug_created: savedFilterState.user_slug_created,
        due_date: savedFilterState.due_date ? new Date(savedFilterState.due_date) : null,
        property_slug: savedFilterState.property_slug,
        selectedUserList: savedFilterState.selectedUserList,
        selectedPriorityType: savedFilterState.selectedPriorityType,
        selectedStatusList: selectedDashboardStatus == undefined ? savedFilterState.selectedStatusList : selectedDashboardStatus,
        selectedProperty: savedFilterState.selectedProperty,
        selectedUserListCreated: savedFilterState.selectedUserListCreated,
        isFilterTrue: true,
        module_search: savedFilterState.module_search,
        is_filter: savedFilterState.is_filter,
        formattedData: savedFormattedData || [],
      }, () => {
        let date = "";
        if (this.state.due_date) {
          date = Moment(this.state.due_date).format("YYYY-MM-DD");
        }
        let queryString =
          "user_slug=" + (this.state.user_slug ? this.state.user_slug : '') +
          "&is_filter=1&" +
          "priority_type=" + (this.state.priority_type ? this.state.priority_type : '') +
          "&status_id=" + (this.state.status_id ? this.state.status_id : '') +
          "&created_by=" + (this.state.user_slug_created ? this.state.user_slug_created : '') +
          "&due_date=" + (date ? date : '') +
          "&property_slug=" + (this.state.property_slug ? this.state.property_slug : '');
        this.getData(queryString);
        this.getProperty();
        this.setState({ tableQueryString: "", customQueryString: queryString, savedFilterState: savedFilterState });
      });
    } else {
      if (this.state.statusFilter !== undefined) {
        var status = 0;
        if (this.state.statusFilter === "pending") {
          status = 1;
        }
        if (this.state.statusFilter === "overdue") {
          status = 3;
        }
        if (this.state.statusFilter === "completed") {
          status = 2;
        }
        setTimeout(
          () =>  this.customFilter(), global.filter_time
        );
        this.setState({ status_id: status });
        let actionStatus = global.actionItemStatus;
        let selectedDashboardStatus = [];
        actionStatus.map((i) => {
          if (i.value === status) {
            selectedDashboardStatus.push(i);
          }
        });
        this.setState({ selectedStatusList: selectedDashboardStatus });
      } else {
        this.getData();
        this.getProperty();
      }
    }
  }
  getPropertySlug(property_slug) {
    this.setState({ property_slug: property_slug });
    setTimeout(() => {
      this.getData();
        this.getProperty();
    }, 200);
    this.setState({
      unit_number: "",
      module_search: [],
      is_search: 0,
    });
  }
  modifyTaskName(taskName) {
    // Create a temporary element to manipulate the HTML string
    const tempElement = document.createElement('div');
    tempElement.innerHTML = taskName;

    // Find all links in the element
    const links = tempElement.querySelectorAll('a');
    links.forEach(link => {
      link.setAttribute('target', '_blank');
    });

    // Return the modified HTML
    return tempElement.innerHTML;
  }

  async getData(queryString = "") {
    this.setState({ showSpinner: true });
    if (this.state.isFirstLoad) {
      this.setState({ loading: true, isFirstLoad: false });
    }
    // let localSelectedProperty = "";
    // if (localStorage.getItem("activePropertyCount") == 1) {
    //   localSelectedProperty = {
    //     label: localStorage.getItem("singlePropertyName"),
    //     value: localStorage.getItem("singlePorpertySlug"),
    //   };
    // } else {
    // if (localStorage.getItem("outSidePorpertySlug") !== undefined &&
    //   localStorage.getItem("outSidePorpertySlug") !== null &&
    //   localStorage.getItem("outSidePorpertySlug") !== "") {
    //   let propertySlug = localStorage.getItem("outSidePorpertySlug");
    //   let propertyName = localStorage.getItem("selectedPropertyName");
    //   queryString = "property_slug=" + propertySlug;
    //   localSelectedProperty = {
    //     label: propertyName,
    //     value: propertySlug,
    //   };
    // }
    // }
    let propertySlug = "";
    let propertyName = "";
    let localSelectedProperty = "";
    if (localStorage.getItem("activePropertyCount") == 1) {
      localSelectedProperty = {
        label: localStorage.getItem("singlePropertyName"),
        value: localStorage.getItem("singlePorpertySlug"),
        };
    } else {
      if (this.state.singleScreen === true) {
        localSelectedProperty = this.state.selectedProperty;
          if (queryString == "resetCall") {
            localSelectedProperty = [];
          }
      } else {
        if (localStorage.getItem("outSidePorpertySlug") !== undefined &&
        localStorage.getItem("outSidePorpertySlug") !== null &&
          localStorage.getItem("outSidePorpertySlug") !== "") {
        propertySlug = localStorage.getItem("outSidePorpertySlug");
        propertyName = localStorage.getItem("selectedPropertyName");
        if (this.state.fistLoad === false) {
          queryString = queryString ? `${queryString}&property_slug=${propertySlug}` : `property_slug=${propertySlug}`;
          this.setState({fistLoad:true});
        } else {
          queryString += `&property_slug=${propertySlug}`;
        }
         localSelectedProperty = {
          label: propertyName,
          value: propertySlug,
        };
        } else {
          localSelectedProperty = [];
          if (queryString == "resetCall") {
            localSelectedProperty = [];
          }
          
      }
      }
     
    }
    var list = [];
    var totalRecords = 0;
    let res = await ActionItemService.getList(queryString);
    if (global.successStatus.includes(res.status)) {
      list = res.data.data ? res.data.data : [];
      totalRecords = res.data.total;
    }
    if (queryString !== "resetCall") {
      this.setState({ showFilter: false });
    }
    this.setState({
      loading: false,
      isFilterTrue: false,
      total_record: totalRecords,
      records: list,
      selectedProperty:localSelectedProperty,
      showSpinner: false
    });
  }

  //get property data
  async getProperty(queryString = "") {
    var propertyList = [];
    var propertyListData = [];
    let res = await PropertyService.getPropertyList(
      "is_dropdown=1" + (queryString ? "&" + queryString : "")
    );
    if (global.successStatus.includes(res.status)) {
      propertyList = res.data ? res.data : [];
    }
    if (propertyList.length > 0) {
      propertyList.forEach((item) => {
        propertyListData.push({
          label: item.property_name,
          value: item.slug,
        });
      });
    }
    this.setState({
      propertyList: propertyListData,
    });
  }
  // Get Users List
  async getUserList(queryString = "") {
    // this.setState({ loading: true });
    var userList = [];
    var userListData = [];
    let res = await UserService.getUserList(
      "is_dropdown=1" + (queryString ? "&" + queryString : "")
    );
    if (global.successStatus.includes(res.status)) {
      userList = res.data ? res.data : [];
    }

    userList.forEach((item) => {
      //if (item.role_id >= global.roleTypeId) {
        userListData.push({
          label: item.full_name,
          value: item.slug,
        });
      //}
    });
    this.setState({ userList: userListData });
    // this.setState({ loading: false });
  }

  filterToggle = () => {
    if (this.state.showFilter === 1) {
      this.setState({ showFilter: 0 });
      document.body.classList.remove("bdy_over");
    } else {
      this.setState({ priorityType: global.priorityType });
      this.setState({ statusList: global.actionItemStatus });
      this.getUserList();
      this.setState({ showFilter: 1 });
      document.body.classList.add("bdy_over");
      // All Apis hit from here
    }
  };

  closeModal() {
    this.setState({ showAlertModal: false });
  }

  changeHandler = (event) => {
    let input = this.state.input;
    let value = event.target.value;
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });

    // Validate
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };

  // Technician/User Change Handler
  handleChangeUserList(value) {
    let user_slug = [];
    if (value !== null && value.length > 0) {
      value.forEach((item, i) => {
        user_slug.push(item.value);
      });
    }
    this.setState({
      selectedUserList: value,
      user_slug: value.value,
      assignee_name: value.label,
    });
  }

  handleChangeUserListCreatedBy(value) {
    let user_slug_created = [];
    if (value !== null && value.length > 0) {
      value.forEach((item, i) => {
        user_slug_created.push(item.value);
      });
    }
    this.setState({
      selectedUserListCreated: value,
      user_slug_created: value.value,
      created_name: value.label,
    });
  }
  // Priority  Change Handler
  handleChangePriority(value) {
    let priority_type = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        priority_type.push(item.value);
      });
    }
    this.setState({
      selectedPriorityType: value,
      priority_type: value.value,
      priority_name: value.label,
    });
  }

  // Status Change Handler
  handleChangeStatus(value) {
    let status_id = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        status_id.push(item.value);
      });
    }
    this.setState({
      selectedStatusList: value,
      status_id: value.value,
      status_name: value.label,
    });
  }

   //property type handle
   handleChangeProperty(value) {
    let property_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        property_slug.push(item.value);
      });
    }
    this.setState({
      selectedProperty: value,
      property_slug: value.value,
      singleScreen: (localStorage.getItem("outSidePorpertySlug") !== undefined &&
      localStorage.getItem("outSidePorpertySlug") !== null &&
        localStorage.getItem("outSidePorpertySlug") !== "" ? true:false),
      singleScreenProperty: value.label,
      property_name1: value.label,
    });
  }
  searchToggle = () => {
    if (this.state.isSearch === 1) {
      this.setState({ isSearch: 0 });
    } else {
      // this.getData("tab=" + this.state.tab);
      this.setState({ isSearch: 1 });
    }
  };
  customFilter() {
    let date = "";
    if (this.state.due_date) {
      date = Moment(this.state.due_date).format("YYYY-MM-DD");
    }
    let queryString = 
      "property_slug=" + (this.state.property_slug ? this.state.property_slug : '') +
      "&due_date=" + (date ? date : '') +
      "&status_id=" + (this.state.status_id ? this.state.status_id : '') +
      "&priority_type=" + (this.state.priority_type ? this.state.priority_type : '') +
      "&created_by=" + (this.state.user_slug_created ? this.state.user_slug_created : '') +
      "&user_slug=" + (this.state.user_slug ? this.state.user_slug : '') +
      "&per_page=" + (this.state.perPage ? this.state.perPage : "") +
      "&is_filter=1&";
      if (this.state.perPage == this.state.total_record) {
        queryString += "&all_records=all";
      }
    if (queryString !== "") {
      this.setState({ lastQueryString: queryString });
      this.searchToggle();
      this.setState({ is_filter: 1 });
    }

    const dataFiltered = JSON.stringify({
      user_slug: this.state.user_slug,
      priority_type: this.state.priority_type,
      status_id: this.state.status_id,
      user_slug_created: this.state.user_slug_created,
      due_date: this.state.due_date,
      property_slug: this.state.property_slug,
      selectedUserList: this.state.selectedUserList,
      selectedPriorityType: this.state.selectedPriorityType,
      selectedStatusList: this.state.selectedStatusList,
      selectedProperty: this.state.selectedProperty,
      selectedUserListCreated: this.state.selectedUserListCreated,
      is_filter: 1
    });
    localStorage.setItem('actionItemFilterState', dataFiltered);
    const result1 = JSON.parse(dataFiltered);
    
    const formattedData = [];
    if (result1?.selectedProperty?.label) {
      formattedData.push(`Property: ${result1?.selectedProperty?.label}`);
    } else {
      if (
        (this.state.singleScreenProperty && this.state.singleScreenProperty !== "All Properties") || 
        (localStorage.getItem("selectedPropertyName") && localStorage.getItem("selectedPropertyName") !== "All Properties")
      ) {
        const propertyName = this.state.singleScreenProperty 
          ? this.state.singleScreenProperty 
          : localStorage.getItem("selectedPropertyName");
        formattedData.push(`Property: ${propertyName}`);
      }
    }
    if (result1?.selectedUserList?.label) {
      formattedData.push(`Assigned To: ${result1?.selectedUserList?.label}`);
    }
    if (result1?.selectedUserListCreated?.label) {
      formattedData.push(`Created By: ${result1?.selectedUserListCreated?.label}`);
    }
    if (result1?.due_date) {
      formattedData.push(`Due Date: ${Moment(result1?.due_date).format("DD MMM, YY")}`);
    }
    if (result1?.selectedPriorityType?.label) {
      formattedData.push(`Priority: ${result1?.selectedPriorityType?.label}`);
    }
    if (result1?.selectedStatusList?.label) {
      formattedData.push(`Status: ${result1?.selectedStatusList?.label}`);
    }
    this.setState({ formattedData });
    localStorage.setItem('formattedDataAction', JSON.stringify(formattedData));
    // Save the filter state to local storage
    this.getData(queryString);
    if (this.state.showFilter === 1) {
      document.body.classList.remove("bdy_over");
    }
  }


  resetData() {
    this.setState({ is_filter: 0 });
    this.setState({
      due_date: "",
      selectedUserList: [],
      selectedPriorityType: [],
      selectedStatusList: [],
      user_slug: "",
      priority_type: "",
      status_id: "",
      lastQueryString: "",
      property_slug : "",
      selectedProperty: [],
      singleScreenProperty: "",
      singleScreen: false,
      created_by:'',
      selectedUserListCreated:[],
      formattedData: [],
    });
    // Remove filter state from local storage
    localStorage.removeItem('actionItemFilterState');
    localStorage.removeItem('formattedDataAction');
    this.getData("resetCall");
  }

  tableChangeHandler = (data) => {
  
    // Function to create query parameters
    const createQueryParams = (data) => {
      const params = new URLSearchParams();
      Object.keys(data).forEach((key) => {
        if (key === "sort_order" && data[key]) {
          params.append("sort_order", data[key].order);
          params.append("sort_column", data[key].column);
        } else {
          let newKey = key;
          if (key === "page_number") {
            newKey = "page";
          } else if (key === "sort_order") {
              data[key] = "asc";
            } else if (key === "page_size") {
              newKey = "per_page";
              this.setState({ perPage: data[key]});
            }
          params.append(newKey, data[key]);
        }
      });
      if (data.page_size == this.state.total_record) {
        params.append("all_records", "all");
      }
      
      return params.toString();
    };
    
    const pageSize = Number(data.page_size);
    const validPageSizes = [10,20, 50, 100];

    let possible = this.state.total_record / pageSize + (this.state.total_record % pageSize ? 1 : 0);

    if (data.page_number > possible || ( pageSize && !validPageSizes.includes(pageSize))) {
      data.page_number = 1; 
    }
    let queryString = createQueryParams(data);
  
    if (data.filter_value === "") {
      queryString += `&${this.state.customQueryString}`;
    }
  
    this.setState({ tableQueryString: queryString });
  
    if (data.filter_value !== this.state.filter_value) {  
      clearTimeout(this.state.filter_time);
      this.setState({
        filter_time: setTimeout(
          () => this.getData(queryString),
          global.filter_time
        ),
        filter_value: data.filter_value,
      });
    } else {
      if (this.state.firstLoad === true) {
        queryString = new URLSearchParams({
          page: data.page_number,
          page_size: data.page_size,
          sort_order: data.sort_order.order,
          sort_column: data.sort_order.column,
        }).toString();
      }
  
      // Parse the last query string to update parameters
    const updatedParams = new URLSearchParams(this.state.lastQueryString);
    
    // Check if 'per_page' exists in the parameters
    if (updatedParams.has('per_page')) {
        updatedParams.delete('per_page');
        // Update state with modified parameters
        this.setState({ lastQueryString: updatedParams.toString() });
    }
      // Fetch data with the updated query string
      this.getData(`${queryString}${updatedParams.toString()}`).finally(() => {
          // Hide the spinner after data is fetched
          this.setState({ showSpinner: false });
      });
    }
  };
  rowClickedHandler = (event, data, rowIndex) => {
    this.props.history.push("/action-item/update/" + data.slug);
  };

  customValidate() {
    let isValid = true;
    return isValid;
  }
  limitTextTo50Words(htmlContent) {
    // Parse HTML content to extract text
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const textContent = doc.body.textContent || "";

    // Limit the text content to 50 characters
    const limit = 30;
    let result = textContent.slice(0, limit);

    // Append "..." if the original content is longer than 50 characters
    if (textContent.length > limit) {
        result += '...';
    }

    return result;
  }

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
            ? "black"
            : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "gray"
            : state.isFocused && "gray",
        fontFamily: "Roboto-Regular",
        fontSize: "16px",
      }),
    };
    return (
      <div>
        <main>
        {this.state.showSpinner && (
            <div className="spinnerLoader1">
              <div className="toploader1">
                <img src={require("../../assets/images/Loader-new.gif").default} alt="Loading" />
              </div>
            </div>
          )}
          {this.state.showSpinner}
          <div className="container-fluid">
            <div className="row row-xs">
              <div className="col-md-12">
                <div className="brandSection">
                  <div className="dashbaord-pageHeadertitle">
                    <h3 className="flex-column">
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <h3>Action Items</h3>
                        <div className="btnNavigate d-flex justify-content-end">
                        {global.userPermissions.checkPermission("action_items-add") && (
                          <Link to={"/action-item/add"}>
                            <button className="gf-primary-btn-small-one mg-l-7 btn btn-primary ">
                              Add Action Item
                            </button>
                          </Link> )}
                          <button
                            onClick={this.filterToggle}
                            className="gf-primary-btn-small-one mg-l-7 btn btn-primary"
                          >
                            {" "}
                            {this.state.showFilter === 1 ? "Filter" : "Filter"}
                          </button>
                        </div>
                      </div>
                      <span>All Action Items</span>
                    </h3>
                  </div>

                  {this.state.showFilter ? (
                    <Row className="align-items-start fliter_back">
                      <div className="order_form">
                        <div className="d-flex justify-content-between align-items-center w-100 ">
                          <h3
                            className="hand-cursor back-size"
                            onClick={this.filterToggle}
                          >
                            <img src={back} alt="" />
                            Back
                          </h3>
                        </div>
                        <h3>Filter</h3>
                        <div className="filter-box-scroll">
                          <Row className="align-items-start justify-content-between m-0 p-0">
                            <Col
                              md={12}
                              lg={12}
                              xl={12}
                              className="mb-md-0 mb-3 pl-0"
                            >
                              <label className="form-label text-left mg-b-5 mt-0">
                                Property{" "}
                              </label>
                              <Select
                                className="multiselect new_drop"
                                menuPlacement="auto"
                                value={this.state.selectedProperty}
                                options={this.state.propertyList}
                                isSearchable={true}
                                onChange={(value) =>
                                  this.handleChangeProperty(value)
                                }
                                defaultValue={this.state.selectedStatusList}
                                autoComplete="off"
                                getOptionValue={(option) => `${option.label}`}
                                styles={customStyles}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary75: "#808080",
                                    primary50: "#808080",
                                    primary25: "#808080",
                                  },
                                })}
                              />
                            </Col>
                            <Col
                              md={12}
                              lg={12}
                              xl={12}
                              className="mb-md-0 mb-3 pl-0"
                            >
                              <label className="form-label text-left mg-b-5 ">
                                Status Type{" "}
                              </label>
                              <Select
                                className="multiselect new_drop"
                                menuPlacement="auto"
                                value={this.state.selectedStatusList}
                                options={this.state.statusList}
                                isSearchable={true}
                                onChange={(value) =>
                                  this.handleChangeStatus(value)
                                }
                                defaultValue={this.state.selectedStatusList}
                                autoComplete="off"
                                getOptionValue={(option) => `${option.label}`}
                                styles={customStyles}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary75: "#808080",
                                    primary50: "#808080",
                                    primary25: "#808080",
                                  },
                                })}
                              />
                            </Col>
                            <Col
                              md={12}
                              lg={12}
                              xl={12}
                              className="mb-md-0 mb-3 pl-0 pb-"
                            >
                              <label className="form-label text-left mg-b-5">
                                Due Date{" "}
                              </label>
                              <DatePicker
                                className="form-control max_width_100"
                                showMonthDropdown
                                showYearDropdown
                                scrollableYearDropdown
                                autoComplete="off"
                                yearDropdownItemNumber={
                                  global.yearDropdownItemNumber
                                }
                                name="due_date"
                                placeholderText="dd-mm-yy"
                                dateFormat="dd MMM yy"
                                selected={this.state.due_date}
                                onChange={(data) =>
                                  this.changeHandler({
                                    target: {
                                      type: "date",
                                      name: "due_date",
                                      value: data,
                                    },
                                  })
                                }
                              />
                            </Col>
                            <Col
                              md={12}
                              lg={12}
                              xl={12}
                              className="mb-md-0 mb-3 pl-0 "
                            >
                              <label className="form-label text-left mg-b-5">
                                Priority{" "}
                              </label>
                              <Select
                                className="multiselect new_drop"
                                menuPlacement="auto"
                                value={this.state.selectedPriorityType}
                                options={this.state.priorityType}
                                isSearchable={true}
                                onChange={(value) =>
                                  this.handleChangePriority(value)
                                }
                                defaultValue={this.state.selectedPriorityType}
                                autoComplete="off"
                                getOptionValue={(option) => `${option.label}`}
                                styles={customStyles}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary75: "#808080",
                                    primary50: "#808080",
                                    primary25: "#808080",
                                  },
                                })}
                              />
                            </Col>
                            <Col
                              md={12}
                              lg={12}
                              xl={12}
                              className="mb-md-0 mb-3 pl-0"
                            >
                              <label className="form-label text-left mg-b-5">
                                Assigned To{" "}
                              </label>
                              <Select
                                className="multiselect new_drop"
                                menuPlacement="auto"
                                value={this.state.selectedUserList}
                                options={this.state.userList}
                                onChange={(value) =>
                                  this.handleChangeUserList(value)
                                }
                                defaultValue={this.state.selectedUserList}
                                autoComplete="off"
                                getOptionValue={(option) => `${option.label}`}
                                styles={customStyles}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary75: "#808080",
                                    primary50: "#808080",
                                    primary25: "#808080",
                                  },
                                })}
                              />
                            </Col>
                            <Col
                              md={12}
                              lg={12}
                              xl={12}
                              className="mb-md-0 mb-3 pl-0"
                            >
                              <label className="form-label text-left mg-b-5">
                                Created By{" "}
                              </label>
                              <Select
                                className="multiselect new_drop"
                                menuPlacement="auto"
                                value={this.state.selectedUserListCreated}
                                options={this.state.userList}
                                onChange={(value) =>
                                  this.handleChangeUserListCreatedBy(value)
                                }
                                defaultValue={
                                  this.state.selectedUserListCreated
                                }
                                autoComplete="off"
                                getOptionValue={(option) => `${option.label}`}
                                styles={customStyles}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary75: "#808080",
                                    primary50: "#808080",
                                    primary25: "#808080",
                                  },
                                })}
                              />
                            </Col>
                            <Row className="row col-md-12 mg-t-30 justify-content-between w-100 pr-0">
                              <button
                                onClick={this.resetData}
                                className="btn-success-outline"
                              >
                                Reset
                              </button>
                              <button
                                onClick={this.customFilter}
                                className="btn-success mg-l-0 mg-r-20"
                              >
                                {this.state.isFilterTrue
                                  ? global.loader
                                  : "Search"}
                              </button>
                            </Row>
                          </Row>
                        </div>
                      </div>
                    </Row>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="brandList dashboardRightcard">
            <PropertySelection
                propertySlug={this.getPropertySlug.bind(this)}
                outSidePropertySlug={this.state.outSidePropertySlug}
              />
            {this.state.is_filter === 1 ? (
                <>
                  {/* <div className="col-xxl-12 col-sm-12 pd-lg-r-30 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                    <div className="custm-filter">
                      <div> */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="checklist_table_heading">
                        {" "}
                        <span className="lspan">
                        {(this.state.formattedData && this.state.formattedData.length && this.state.formattedData.join(', ')) ? <> Search Applied On:&nbsp;{" "} </>: ''}
                        </span>
                        <span className="rspan">
                        {(this.state.formattedData && this.state.formattedData.length > 0) ? this.state.formattedData.join(', ') : ''}

                        {(this.state.formattedData && this.state.formattedData.length > 0) && (
                          <a
                            type="button"
                            onClick={this.resetData}
                            className="global-flt-clearBtn"
                          >
                            Clear
                          </a>
                        )}
                          </span>
                      {/* </div> */}
                    </div>
                    </div>
                  </div>
                </>
              ) : (
              ""
            )}
            {localStorage.getItem("outSidePorpertySlug") && (this.state.formattedData == undefined || this.state.formattedData.length == 0) ? (<>
                <div className="row">
                <div className="col-md-12">
                    <div className="checklist_table_heading"><span className="lspan">Search Applied On:&nbsp;</span><span className="rspan">{this.state.singleScreenProperty ? this.state.singleScreenProperty:localStorage.getItem("selectedPropertyName") }</span></div>
                </div>
              </div>
              </>) :""}
              <ReactDatatable
                className="table no-wrap mg-b-30 pd-b-2"
                config={this.state.config}
                records={this.state.records}
                columns={this.state.columns}
                extraButtons={this.state.extraButtons}
                dynamic={true}
                loading={this.state.loading}
                total_record={this.state.total_record}
                onChange={this.tableChangeHandler}
                onRowClicked={this.rowClickedHandler}
              />
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default ActionItem;

